import {
  Person,
  LayoutCells,
  Video,
  Cube,
  ChartColumn,
  TriangleExclamation,
  // Speedometer, — нужен пункту «Электронное OEE», он временно скрыт.
  CircleQuestion,
  Persons,
  Gear,
} from "@gravity-ui/icons";

/**
 * Пункты меню сайдбара. `id` совпадает с первым сегментом маршрута
 * (`/cameras`, `/violations`, …) — по нему MainLayout подсвечивает активный пункт.
 *
 * `navKeys` — ключи backend-навигации (`GET /me/navigation`), любой из которых
 * открывает пункт. Без `navKeys` пункт в каталоге backend не представлен и
 * виден всегда.
 */
export const BASE_MENU_ITEMS = [
  // ТЗ V5 №17: порядок пунктов задан владельцем. «Оптимизация» — новое имя
  // «Статистики» только в меню; маршрут и страница прежние.
  { id: "profile", label: "Личный кабинет", Icon: Person, navKeys: ["profile", "profile.control"] },
  { id: "cameras", label: "Камеры", Icon: Video, navKeys: ["monitoring.frames", "monitoring.live", "monitoring.archive"] },
  { id: "summary", label: "Сводка", Icon: LayoutCells, navKeys: ["summary", "summary.overview", "summary.business_metrics", "analytics.operational_issues"] },
  { id: "violations", label: "События", Icon: TriangleExclamation, navKeys: ["events", "events.list", "events.rules", "events.change_requests", "events.camera_settings"] },
  { id: "statistics", label: "Оптимизация", Icon: ChartColumn, navKeys: ["analytics.statistics", "analytics.gantt"] },
  { id: "equipment", label: "Оборудование", Icon: Cube, navKeys: ["monitoring.equipment"] },
  // Временно скрыто: страница пока всегда пустая. Маршрут /eoee и EOEEPage
  // оставлены — чтобы вернуть пункт, раскомментировать строку и импорт Speedometer.
  // { id: "eoee", label: "Электронное OEE", Icon: Speedometer },
  { id: "help", label: "Помощь", Icon: CircleQuestion },
];

/** Видны только администратору (`isAdmin()`). */
export const ADMIN_MENU_ITEMS = [
  { id: "roles", label: "Роли", Icon: Persons },
  { id: "admin", label: "Админ панель", Icon: Gear },
];

/** Подпись роли для нижней карточки аккаунта. */
export const ROLE_LABELS = {
  admin: "Администратор",
  user: "Пользователь",
};
